import React, { useState } from "react";
import "./Contacts.scss";
import ContactsContainer from "./ContactsContainer/ContactsContainer.js";

const Contacts = ({}) => {
  const [listView, setListView] = useState(true);

  return (
    <div className="profile-contacts-container">
      <ContactsContainer listView={listView} />
    </div>
  );
};

export default Contacts;
